module.exports = __webpack_public_path__ + "static/img/message.56a9b02.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/message.png
// module id = Ekz2
// module chunks = 1